/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseAppearancePropertiesDefaultViewColumns } from './DatabaseAppearancePropertiesDefaultViewColumns';
import {
    DatabaseAppearancePropertiesDefaultViewColumnsFromJSON,
    DatabaseAppearancePropertiesDefaultViewColumnsFromJSONTyped,
    DatabaseAppearancePropertiesDefaultViewColumnsToJSON,
} from './DatabaseAppearancePropertiesDefaultViewColumns';
import type { DatabaseFontSizeEnum } from './DatabaseFontSizeEnum';
import {
    DatabaseFontSizeEnumFromJSON,
    DatabaseFontSizeEnumFromJSONTyped,
    DatabaseFontSizeEnumToJSON,
} from './DatabaseFontSizeEnum';
import type { DatabaseFooterProperties } from './DatabaseFooterProperties';
import {
    DatabaseFooterPropertiesFromJSON,
    DatabaseFooterPropertiesFromJSONTyped,
    DatabaseFooterPropertiesToJSON,
} from './DatabaseFooterProperties';
import type { DatabaseHeaderProperties } from './DatabaseHeaderProperties';
import {
    DatabaseHeaderPropertiesFromJSON,
    DatabaseHeaderPropertiesFromJSONTyped,
    DatabaseHeaderPropertiesToJSON,
} from './DatabaseHeaderProperties';

/**
 * 
 * @export
 * @interface DatabaseAppearanceProperties
 */
export interface DatabaseAppearanceProperties {
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseAppearanceProperties
     */
    hideHeader?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseAppearanceProperties
     */
    hideContent?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseAppearanceProperties
     */
    hideFooter?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    colorScheme?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    secondaryColorScheme?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    bodyBackgroundColor?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    stageBackgroundColor?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    ctaPrimaryColor?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    ctaSecondaryColor?: string;
    /**
     * 
     * @type {number}
     * @memberof DatabaseAppearanceProperties
     */
    ctaBorderRadius?: number;
    /**
     * 
     * @type {number}
     * @memberof DatabaseAppearanceProperties
     */
    ctaBorderWidth?: number;
    /**
     * 
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    selectionBtnPrimaryColor?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    selectionBtnSecondaryColor?: string;
    /**
     * 
     * @type {number}
     * @memberof DatabaseAppearanceProperties
     */
    selectionBtnBorderRadius?: number;
    /**
     * 
     * @type {number}
     * @memberof DatabaseAppearanceProperties
     */
    selectionBtnBorderWidth?: number;
    /**
     * 
     * @type {DatabaseFontSizeEnum}
     * @memberof DatabaseAppearanceProperties
     */
    headerFontSize?: DatabaseFontSizeEnum;
    /**
     * font family of database entries header
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    headerFontFamily?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    headerFontColor?: string;
    /**
     * 
     * @type {DatabaseFontSizeEnum}
     * @memberof DatabaseAppearanceProperties
     */
    bodyFontSize?: DatabaseFontSizeEnum;
    /**
     * font family of database entries body
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    bodyFontFamily?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    bodyFontColor?: string;
    /**
     * font family of database entries header
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    footerFontFamily?: string;
    /**
     * 
     * @type {DatabaseFontSizeEnum}
     * @memberof DatabaseAppearanceProperties
     */
    footerFontSize?: DatabaseFontSizeEnum;
    /**
     * 
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    footerFontColor?: string;
    /**
     * 
     * @type {DatabaseFontSizeEnum}
     * @memberof DatabaseAppearanceProperties
     */
    detailsFontSize?: DatabaseFontSizeEnum;
    /**
     * font family of details modal
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    detailsFontFamily?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    detailsFontColor?: string;
    /**
     * default items per page
     * @type {number}
     * @memberof DatabaseAppearanceProperties
     */
    defaultPageSize?: number;
    /**
     * frontend interaction mode
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    interactionMode?: DatabaseAppearancePropertiesInteractionModeEnum;
    /**
     * 
     * @type {DatabaseHeaderProperties}
     * @memberof DatabaseAppearanceProperties
     */
    header?: DatabaseHeaderProperties;
    /**
     * 
     * @type {DatabaseFooterProperties}
     * @memberof DatabaseAppearanceProperties
     */
    footer?: DatabaseFooterProperties;
    /**
     * the selected ui template for this instance
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    uiTemplate?: string;
    /**
     * optional variant of UI Template
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    templateVariant?: string;
    /**
     * initial view mode of the database
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    defaultView?: DatabaseAppearancePropertiesDefaultViewEnum;
    /**
     * 
     * @type {DatabaseAppearancePropertiesDefaultViewColumns}
     * @memberof DatabaseAppearanceProperties
     */
    defaultViewColumns?: DatabaseAppearancePropertiesDefaultViewColumns;
    /**
     * flow of the fields in the details form
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    detailsFieldAlignment?: DatabaseAppearancePropertiesDetailsFieldAlignmentEnum;
    /**
     * alignment of the labels in the details form
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    detailsLabelAlignment?: DatabaseAppearancePropertiesDetailsLabelAlignmentEnum;
    /**
     * the background color of the details modal
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    detailsBackgroundColor?: string;
    /**
     * border style of the details modal
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    detailsBorderType?: DatabaseAppearancePropertiesDetailsBorderTypeEnum;
    /**
     * the border color of the details modal
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    detailsBorderColor?: string;
}


/**
 * @export
 */
export const DatabaseAppearancePropertiesInteractionModeEnum = {
    Sidebar: 'SIDEBAR',
    BurgerMenu: 'BURGER_MENU',
    Buttons: 'BUTTONS',
    None: 'NONE'
} as const;
export type DatabaseAppearancePropertiesInteractionModeEnum = typeof DatabaseAppearancePropertiesInteractionModeEnum[keyof typeof DatabaseAppearancePropertiesInteractionModeEnum];

/**
 * @export
 */
export const DatabaseAppearancePropertiesDefaultViewEnum = {
    List: 'LIST',
    Grid: 'GRID',
    Gallery: 'GALLERY',
    Children: 'CHILDREN'
} as const;
export type DatabaseAppearancePropertiesDefaultViewEnum = typeof DatabaseAppearancePropertiesDefaultViewEnum[keyof typeof DatabaseAppearancePropertiesDefaultViewEnum];

/**
 * @export
 */
export const DatabaseAppearancePropertiesDetailsFieldAlignmentEnum = {
    LeftRight: 'LEFT_RIGHT',
    TopBottom: 'TOP_BOTTOM'
} as const;
export type DatabaseAppearancePropertiesDetailsFieldAlignmentEnum = typeof DatabaseAppearancePropertiesDetailsFieldAlignmentEnum[keyof typeof DatabaseAppearancePropertiesDetailsFieldAlignmentEnum];

/**
 * @export
 */
export const DatabaseAppearancePropertiesDetailsLabelAlignmentEnum = {
    Top: 'TOP',
    Left: 'LEFT',
    Right: 'RIGHT'
} as const;
export type DatabaseAppearancePropertiesDetailsLabelAlignmentEnum = typeof DatabaseAppearancePropertiesDetailsLabelAlignmentEnum[keyof typeof DatabaseAppearancePropertiesDetailsLabelAlignmentEnum];

/**
 * @export
 */
export const DatabaseAppearancePropertiesDetailsBorderTypeEnum = {
    Full: 'FULL',
    Bottom: 'BOTTOM',
    None: 'NONE'
} as const;
export type DatabaseAppearancePropertiesDetailsBorderTypeEnum = typeof DatabaseAppearancePropertiesDetailsBorderTypeEnum[keyof typeof DatabaseAppearancePropertiesDetailsBorderTypeEnum];


/**
 * Check if a given object implements the DatabaseAppearanceProperties interface.
 */
export function instanceOfDatabaseAppearanceProperties(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseAppearancePropertiesFromJSON(json: any): DatabaseAppearanceProperties {
    return DatabaseAppearancePropertiesFromJSONTyped(json, false);
}

export function DatabaseAppearancePropertiesFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseAppearanceProperties {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'hideHeader': !exists(json, 'hideHeader') ? undefined : json['hideHeader'],
        'hideContent': !exists(json, 'hideContent') ? undefined : json['hideContent'],
        'hideFooter': !exists(json, 'hideFooter') ? undefined : json['hideFooter'],
        'colorScheme': !exists(json, 'colorScheme') ? undefined : json['colorScheme'],
        'secondaryColorScheme': !exists(json, 'secondaryColorScheme') ? undefined : json['secondaryColorScheme'],
        'bodyBackgroundColor': !exists(json, 'bodyBackgroundColor') ? undefined : json['bodyBackgroundColor'],
        'stageBackgroundColor': !exists(json, 'stageBackgroundColor') ? undefined : json['stageBackgroundColor'],
        'ctaPrimaryColor': !exists(json, 'ctaPrimaryColor') ? undefined : json['ctaPrimaryColor'],
        'ctaSecondaryColor': !exists(json, 'ctaSecondaryColor') ? undefined : json['ctaSecondaryColor'],
        'ctaBorderRadius': !exists(json, 'ctaBorderRadius') ? undefined : json['ctaBorderRadius'],
        'ctaBorderWidth': !exists(json, 'ctaBorderWidth') ? undefined : json['ctaBorderWidth'],
        'selectionBtnPrimaryColor': !exists(json, 'selectionBtnPrimaryColor') ? undefined : json['selectionBtnPrimaryColor'],
        'selectionBtnSecondaryColor': !exists(json, 'selectionBtnSecondaryColor') ? undefined : json['selectionBtnSecondaryColor'],
        'selectionBtnBorderRadius': !exists(json, 'selectionBtnBorderRadius') ? undefined : json['selectionBtnBorderRadius'],
        'selectionBtnBorderWidth': !exists(json, 'selectionBtnBorderWidth') ? undefined : json['selectionBtnBorderWidth'],
        'headerFontSize': !exists(json, 'headerFontSize') ? undefined : DatabaseFontSizeEnumFromJSON(json['headerFontSize']),
        'headerFontFamily': !exists(json, 'headerFontFamily') ? undefined : json['headerFontFamily'],
        'headerFontColor': !exists(json, 'headerFontColor') ? undefined : json['headerFontColor'],
        'bodyFontSize': !exists(json, 'bodyFontSize') ? undefined : DatabaseFontSizeEnumFromJSON(json['bodyFontSize']),
        'bodyFontFamily': !exists(json, 'bodyFontFamily') ? undefined : json['bodyFontFamily'],
        'bodyFontColor': !exists(json, 'bodyFontColor') ? undefined : json['bodyFontColor'],
        'footerFontFamily': !exists(json, 'footerFontFamily') ? undefined : json['footerFontFamily'],
        'footerFontSize': !exists(json, 'footerFontSize') ? undefined : DatabaseFontSizeEnumFromJSON(json['footerFontSize']),
        'footerFontColor': !exists(json, 'footerFontColor') ? undefined : json['footerFontColor'],
        'detailsFontSize': !exists(json, 'detailsFontSize') ? undefined : DatabaseFontSizeEnumFromJSON(json['detailsFontSize']),
        'detailsFontFamily': !exists(json, 'detailsFontFamily') ? undefined : json['detailsFontFamily'],
        'detailsFontColor': !exists(json, 'detailsFontColor') ? undefined : json['detailsFontColor'],
        'defaultPageSize': !exists(json, 'defaultPageSize') ? undefined : json['defaultPageSize'],
        'interactionMode': !exists(json, 'interactionMode') ? undefined : json['interactionMode'],
        'header': !exists(json, 'header') ? undefined : DatabaseHeaderPropertiesFromJSON(json['header']),
        'footer': !exists(json, 'footer') ? undefined : DatabaseFooterPropertiesFromJSON(json['footer']),
        'uiTemplate': !exists(json, 'uiTemplate') ? undefined : json['uiTemplate'],
        'templateVariant': !exists(json, 'templateVariant') ? undefined : json['templateVariant'],
        'defaultView': !exists(json, 'defaultView') ? undefined : json['defaultView'],
        'defaultViewColumns': !exists(json, 'defaultViewColumns') ? undefined : DatabaseAppearancePropertiesDefaultViewColumnsFromJSON(json['defaultViewColumns']),
        'detailsFieldAlignment': !exists(json, 'detailsFieldAlignment') ? undefined : json['detailsFieldAlignment'],
        'detailsLabelAlignment': !exists(json, 'detailsLabelAlignment') ? undefined : json['detailsLabelAlignment'],
        'detailsBackgroundColor': !exists(json, 'detailsBackgroundColor') ? undefined : json['detailsBackgroundColor'],
        'detailsBorderType': !exists(json, 'detailsBorderType') ? undefined : json['detailsBorderType'],
        'detailsBorderColor': !exists(json, 'detailsBorderColor') ? undefined : json['detailsBorderColor'],
    };
}

export function DatabaseAppearancePropertiesToJSON(value?: DatabaseAppearanceProperties | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'hideHeader': value.hideHeader,
        'hideContent': value.hideContent,
        'hideFooter': value.hideFooter,
        'colorScheme': value.colorScheme,
        'secondaryColorScheme': value.secondaryColorScheme,
        'bodyBackgroundColor': value.bodyBackgroundColor,
        'stageBackgroundColor': value.stageBackgroundColor,
        'ctaPrimaryColor': value.ctaPrimaryColor,
        'ctaSecondaryColor': value.ctaSecondaryColor,
        'ctaBorderRadius': value.ctaBorderRadius,
        'ctaBorderWidth': value.ctaBorderWidth,
        'selectionBtnPrimaryColor': value.selectionBtnPrimaryColor,
        'selectionBtnSecondaryColor': value.selectionBtnSecondaryColor,
        'selectionBtnBorderRadius': value.selectionBtnBorderRadius,
        'selectionBtnBorderWidth': value.selectionBtnBorderWidth,
        'headerFontSize': DatabaseFontSizeEnumToJSON(value.headerFontSize),
        'headerFontFamily': value.headerFontFamily,
        'headerFontColor': value.headerFontColor,
        'bodyFontSize': DatabaseFontSizeEnumToJSON(value.bodyFontSize),
        'bodyFontFamily': value.bodyFontFamily,
        'bodyFontColor': value.bodyFontColor,
        'footerFontFamily': value.footerFontFamily,
        'footerFontSize': DatabaseFontSizeEnumToJSON(value.footerFontSize),
        'footerFontColor': value.footerFontColor,
        'detailsFontSize': DatabaseFontSizeEnumToJSON(value.detailsFontSize),
        'detailsFontFamily': value.detailsFontFamily,
        'detailsFontColor': value.detailsFontColor,
        'defaultPageSize': value.defaultPageSize,
        'interactionMode': value.interactionMode,
        'header': DatabaseHeaderPropertiesToJSON(value.header),
        'footer': DatabaseFooterPropertiesToJSON(value.footer),
        'uiTemplate': value.uiTemplate,
        'templateVariant': value.templateVariant,
        'defaultView': value.defaultView,
        'defaultViewColumns': DatabaseAppearancePropertiesDefaultViewColumnsToJSON(value.defaultViewColumns),
        'detailsFieldAlignment': value.detailsFieldAlignment,
        'detailsLabelAlignment': value.detailsLabelAlignment,
        'detailsBackgroundColor': value.detailsBackgroundColor,
        'detailsBorderType': value.detailsBorderType,
        'detailsBorderColor': value.detailsBorderColor,
    };
}

